var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-topic-wrap"},[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-banner"},[_c('p',[_vm._v("随时随地搜索#热门话题")]),_c('p',[_vm._v("根据搜索话题，为您匹配以下视频数据")])])
}]

export { render, staticRenderFns }